import { handleActions } from 'redux-actions';

const {
  data: { user },
  info,
  settings: { endpoints, tokens, hiddenLeversRtqUrl },
} = ADV;

const initialState = {
  user,
  info,
  endpoints,
  tokens,
  hiddenLeversRtqUrl,
};

export default handleActions({}, initialState);
